import script from "./list.vue?vue&type=script&setup=true&lang=js"
export * from "./list.vue?vue&type=script&setup=true&lang=js"

import "./list.vue?vue&type=style&index=0&id=9bcc71e8&lang=less"
import "./list.vue?vue&type=style&index=1&id=9bcc71e8&lang=less&scoped=true"

import exportComponent from "/Users/lily/Documents/7pa/qpyx-super-webstore/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bcc71e8"]])

export default __exports__